import React from "react";

const Checkbox = ({ title, subtitle, checked, onChange, id, disabled = false }) => (
  <label
    htmlFor={id}
    className={[
      "flex gap-[10px] items-start p-[11px_13px] border border-[var(--line)] rounded-[var(--r-sm)] bg-[var(--panel-2)] mb-2.5",
      disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer",
    ].join(" ")}
  >
    <input id={id} type="checkbox" checked={checked} onChange={onChange} disabled={disabled} className="mt-[3px]" />
    <span>
      <b className="font-semibold">{title}</b>
      {subtitle && <small className="block text-[var(--muted)] text-[12.5px]">{subtitle}</small>}
    </span>
  </label>
);

export default Checkbox;
